import { ref } from 'vue'
import { projectAuth, db, messaging } from '../firebase/config'
import { doc, updateDoc, arrayRemove } from 'firebase/firestore'
import { getToken } from 'firebase/messaging'
import { resetState } from '../main_store'
// refs
const error = ref(null)
const isPending = ref(false)

// logout function
const logout = async () => {
  error.value = null
  isPending.value = true

  try {
    // Remove FCM token from user's subscription before logout
    const currentUserId = projectAuth.currentUser?.uid
    console.log('Logout: currentUserId =', currentUserId)

    if (currentUserId) {
      try {
        // Get the current FCM token directly (not from state which may be empty after page refresh)
        console.log('Logout: Getting FCM token...')
        const currentToken = await getToken(messaging, {
          vapidKey: process.env.VUE_APP_VAPID_KEY
        })
        console.log('Logout: currentToken =', currentToken ? currentToken.substring(0, 20) + '...' : 'null')

        if (currentToken) {
          const subDocRef = doc(db, 'subscription', currentUserId)
          console.log('Logout: Removing token from Firestore...')
          await updateDoc(subDocRef, {
            tokens: arrayRemove(currentToken)
          })
          console.log('FCM token removed from subscription on logout')
        } else {
          console.log('Logout: No token to remove')
        }
      } catch (tokenError) {
        // Don't block logout if token removal fails
        console.error('Failed to remove FCM token:', tokenError)
      }
    } else {
      console.log('Logout: No currentUserId, skipping token removal')
    }

    resetState();
    await projectAuth.signOut()
    isPending.value = false
  }
  catch (err) {
    console.log(err.message)
    error.value = err.message
    isPending.value = false
  }
}

const useLogout = () => {
  return { error, logout, isPending }
}

export default useLogout